module.exports = __webpack_public_path__ + "static/media/382572_304357556270706_741753601_n.7c2c03e3.jpg";